import Vue from 'vue';
import { Servicelayer } from '../../../plugins/servicelayer';
import UsersApi from '../generated/api/Users';
import UserRegisterRequestViewModel from '../viewModel/resource/UserRegisterRequestViewModel';

export default (service: Servicelayer) => ({
  ...UsersApi(service),
  async register(req: UserRegisterRequestViewModel) {
    const dto = req.toDTO();
    const originalRegister = { ...UsersApi(service) }.register;
    dto.userLanguage = Vue.$translation.get() ?? 'de';
    dto.userCulture = Vue.$format.userCulture ?? 'de-CH';
    const response = await originalRegister(req, { writeValuesToConsole: false });
    // await Vue.$auth.login({ username: dto.userName, password: dto.password });
    // await Vue.$auth.refresh();
    return response;
  },

  async registerHostadmin(req: UserRegisterRequestViewModel) {
    req.userLanguage = Vue.$translation.get() ?? 'de';
    req.userCulture = Vue.$format.userCulture ?? 'de-CH';
    const originalRegister = { ...UsersApi(service) }.register;
    const response = await originalRegister(req, { writeValuesToConsole: false });
    return response;
  },

});
